import { makeStyles, Theme } from "@material-ui/core";
import React from "react";

interface SectionCardSubDividerProps {
  className?: string;
  dataTestId?: string;
}

export default function SectionCardSubDivider({
  className = "",
  dataTestId,
}: SectionCardSubDividerProps) {
  const classes = useStyles();
  return (
    <div
      className={`${classes.root} ${className}`}
      data-testid={dataTestId}
      role="separator"
      aria-orientation="horizontal"
    />
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: 1,
    backgroundColor: theme.palette.divider,
    margin: "0 -24px",
    alignSelf: "stretch",
  },
}));
